export {};
//# sourceMappingURL=ihttp.service.js.map